<div class="container"  *ngIf="!hide">
    <div class="language-buttons">
      <button *ngFor="let language of languages$ | async" (click)="selectLanguage(language)">
        <span class="fi fi-{{language.code | lowercase}}"></span>
        {{ language.name }}
      </button>
  </div>
</div>